// @flow
import invariant from 'invariant'
import curry from 'lodash/curry'
import * as ActionTypes from './actionTypes'

export const lpush = curry(function lpush(target: string, value: any) {
  return {
    type: ActionTypes.LPUSH,
    payload: {
      target,
      value
    }
  }
})

export const rpush = curry(function rpush(target: string, value: any) {
  return {
    type: ActionTypes.RPUSH,
    payload: {
      target,
      value
    }
  }
})

export const lpop = curry(function lpop(target: string) {
  return {
    type: ActionTypes.LPOP,
    payload: {
      target
    }
  }
})

export const rpop = curry(function rpop(target: string) {
  return {
    type: ActionTypes.RPOP,
    payload: {
      target
    }
  }
})

export const lset = curry(function lset(
  target: string,
  index: number,
  value: any
) {
  return {
    type: ActionTypes.LSET,
    payload: {
      target,
      index,
      value
    }
  }
})

export const lreplace = curry(function lreplace(
  target: string,
  elements: any[]
) {
  invariant(
    Array.isArray(elements),
    'List.lreplace(target, elements) expects an Array of elements to replace the list with'
  )
  return {
    type: ActionTypes.LREPLACE,
    payload: {
      target,
      elements
    }
  }
})

export function lrem(target: string, count: number, value: any) {
  return {
    type: ActionTypes.LREM,
    payload: {
      target,
      count,
      value
    }
  }
}

export function lempty(target: string) {
  return {
    type: ActionTypes.LEMPTY,
    payload: {
      target
    }
  }
}

export function ltrim(target: string, start: number, stop: number = -1) {
  return {
    type: ActionTypes.LTRIM,
    payload: {
      target,
      start,
      stop
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/list/actions.js